var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.997 15H15V9.864c0-2.512-.54-4.447-3.477-4.447-1.412 0-2.359.775-2.746 1.51h-.04V5.652H5.951v9.346h2.9v-4.628c0-1.218.23-2.397 1.74-2.397 1.486 0 1.508 1.39 1.508 2.475V15h2.897ZM1.23 5.653h2.903V15H1.23V5.653ZM2.681 1C1.753 1 1 1.753 1 2.681s.753 1.697 1.681 1.697 1.681-.769 1.681-1.697S3.61 1 2.682 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1 1)",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgLinkedin;